import { apiClient } from '@/services/apiClient';
import type { GlobalSearchPayload } from './search.types';

export const searchApi = {
  search: (query: string, limit = 20) =>
    apiClient.get<GlobalSearchPayload>(
      `/v1/search?q=${encodeURIComponent(query)}&limit=${limit}`,
    ),
  getCommandCenter: () => apiClient.get<GlobalSearchPayload>('/v1/search/command-center'),
};
